import React, { useEffect } from "react";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import AssignmentMarkingList from "../../components/assignment mark/AssignmentMarkingList";
export default function AssignmentMark() {
  useEffect(() => {
    document.title = "Assignment Mark";
  });
  return (
    <>
      <Navbar />
      <Container>
        <div className="px-3 py-20 bg-opacity-10">
          <h2 className="text-4xl text-center ">Assignment Mark</h2>
          <AssignmentMarkingList />
        </div>
      </Container>
    </>
  );
}
